/**
 * 保存数据到服务器
 * @export
 * @param {object} data 需要提交保存的数据
 * @returns Promise
 * @Author:zhangT
 * @Date: 2018-11-12 9:47:56
 * @Last Modified time: 2018-11-15 9:47:56
 */

import http from '@/utils/request'
const apis = {
  getLinkageControlPage(id, pageNum, pageSize) {
    //获取列表
    return http.get({
      url: 'pc/linkageControl/getLinkageControlPage',
      data: {
        id: id,
        pageNum: pageNum,
        pageSize: pageSize
      }
    })
  },
  updateLinkageControlType(controlId, controlType) {
    return http.post({
      url: 'pc/linkageControl/updateLinkageControlType',
      data: {
        controlId,
        controlType
      },
      typea: 1
    })
  },
  openOrCloseDeviceSwtich(data) {
    return http.post({
      url: 'pc/linkageControl/openOrCloseDeviceSwtich',
      data: data,
      typea: 1
    })
  },
  DeviceSwtich(id, val, swtichStatus, attrid) {
    //改变开关
    return http.post({
      url: 'pc/linkageControl/openOrCloseDeviceSwtich',
      data: {
        id: id,
        openValue: val,
        swtichStatus: swtichStatus,
        attributeId: attrid
      }
    })
  },
  //联动控制
  getLinkageControlList(name, pageNum, pageSize) {
    //获取列表
    return http.get({
      url: 'pc/linkageControl/getLinkageControlList',
      data: {
        name: name,
        pageNum: pageNum,
        pageSize: pageSize
      }
    })
  },
  deleteLinkageControl(id) {
    return http.delete({
      url: 'pc/linkageControl/deleteLinkageControl',
      data: {
        id: id
      }
    })
  },
  openOrCloseLinkageControl(id) {
    // 启用停用联动控制
    return http.post({
      url: 'pc/linkageControl/openOrCloseLinkageControl',
      data: {
        id
      }
    })
  },
  getDataHisSwitchList(eid, attrid, beginDate, endDate, currentPage, pagesize) {
    return http.get({
      url: 'objdeviceSwtich/getDataHisSwitchList',
      data: {
        pageNum: currentPage,
        pageSize: pagesize,
        eid: eid,
        attributeId: attrid,
        startDate: beginDate,
        endDate: endDate
      }
    })
  },
  getDeviceAttributeAlarmSet(eid, attrid) {
    //获取设备属性告警
    return http.get({
      url: 'objdeviceAttributeAlarm/getDeviceAttributeAlarmSet',
      data: {
        eid: eid,
        attributeId: attrid
      }
    })
  },
  getDeviceList(pageNum, pageSize, type, value) {
    //设备中心列表（分页）
    return http.get({
      url: 'iotDevice/getIotDeviceList',
      data: {
        pageNum: pageNum,
        pageSize: pageSize,
        type: type,
        value: value
      }
    })
  },
  getDeviceList2(pageNum, pageSize, name, groupId, status) {
    //设备列表（分页）
    return http.get({
      url: '/pc/objDeviceNumerical/getNumericalAttributeList',
      data: {
        pageNum: pageNum,
        pageSize: pageSize,
        name: name,
        groupId: groupId,
        status: status
      }
    })
  },
  getAllDeviceClasses(name, type, pageNum, pageSize) {
    //获取设备分类列表
    return http.get({
      url: 'model/ruleDevice/getRuleDeviceList',
      data: {
        name: name,
        type: type,
        pageNum: pageNum,
        pageSize: pageSize
      }
    })
  },
  addIotPictureDevice(dto) {
    //添加图片设备
    return http.post({
      url: 'iotDevice/addIotPictureDevice',
      data: dto
    })
  },
  addIotVideoDevice(dto) {
    //添加视频设备
    return http.post({
      url: 'objdeviceVideo/addDeviceVideo',
      data: dto
    })
  },
  addDevicePic(dto) {
    //添加图片设备
    return http.post({
      url: 'objdevicePic/addDevicePic',
      data: dto
    })
  },
  getPicList(pageNum, pageSize, name, groupId, status) {
    //获取图片列表
    return http.get({
      url: 'objdevicePic/getPicList',
      data: {
        name: name,
        groupId: groupId,
        status: status,
        pageNum: pageNum,
        pageSize: pageSize
      }
    })
  },
  updateDeviceVideo(dto) {
    //编辑视频设备
    return http.post({
      url: 'objdeviceVideo/updateDeviceVideo',
      data: dto
    })
  },

  getDeviceVideo(id) {
    //获取视频设备详情
    return http.get({
      url: 'objdeviceVideo/getDeviceVideo',
      data: {
        id: id
      }
    })
  },
  getSelectDate(id) {
    //获取查询间隔
    return http.get({
      url: 'data/statistic/getSelectDates',
      data: {
        id: id
      }
    })
  },
  getDevicePic(id) {
    //获取图片设备详情
    return http.get({
      url: 'objdevicePic/getDevicePic',
      data: {
        id: id
      }
    })
  },
  updateDevicePic(dto) {
    //编辑图片设备
    return http.post({
      url: 'objdevicePic/updateDevicePic',
      data: dto
    })
  },

  getVideoList(pageNum, pageSize, name, groupId, status) {
    //获取视频列表
    return http.get({
      url: 'objdeviceVideo/getVideoList',
      data: {
        name: name,
        groupId: groupId,
        status: status,
        pageNum: pageNum,
        pageSize: pageSize
      }
    })
  },

  addIotSwitchDevice(dto) {
    //添加开关设备
    return http.post({
      url: 'iotDevice/addIotSwitchDevice',
      data: dto
    })
  },
  updateDeviceSwtich(dto) {
    //编辑开关设备
    return http.post({
      url: 'objdeviceSwtich/updateDeviceSwtich',
      data: dto
    })
  },

  getSwitchDeviceList(pageNum, pageSize) {
    //获取开关列表
    return http.get({
      url: 'iotDevice/getSwitchDeviceList',
      data: {
        pageNum: pageNum,
        pageSize: pageSize
      }
    })
  },
  getNumericalList(groupId) {
    //获取首页展示设备
    return http.get({
      url: 'objdeviceNumerical/getNumericalList',
      data: {
        pageNum: 1,
        pageSize: 6,
        groupId: groupId
      }
    })
  },
  getNumericalListp(pageNum, pageSize, groupId, name, status) {
    //获取设备
    return http.get({
      url: 'objdeviceNumerical/getDeviceNumericalList',
      data: {
        pageNum: pageNum,
        pageSize: pageSize,
        groupId: groupId,
        name: name
      }
    })
  },
  getGatewaylListByNotInGroupId(id) {
    //获取分组网关设备
    return http.get({
      url: 'config/group/getGatewaylListByNotInGroupId',
      data: {
        id: id
      }
    })
  },
  getNumericalListByNotInGroupId(id) {
    //获取分组数值设备
    return http.get({
      url: 'config/group/getNumericalListByNotInGroupId',
      data: {
        id: id
      }
    })
  },
  getPicListByNotInGroupId(id) {
    //获取分组图片设备
    return http.get({
      url: 'config/group/getPicListByNotInGroupId',
      data: {
        id: id
      }
    })
  },
  getSwtichlListByNotInGroupId(id) {
    //获取分组开关设备
    return http.get({
      url: 'config/group/getSwtichlListByNotInGroupId',
      data: {
        id: id
      }
    })
  },
  getVideoListByNotInGroupId(id) {
    //获取分组视频设备
    return http.get({
      url: 'config/group/getVideoListByNotInGroupId',
      data: {
        id: id
      }
    })
  },

  getDeviceListByInGroupId(groupId, deviceType) {
    //获取分组设备(0数值 1视频 2图片 3开关 4网关)
    return http.get({
      url: '/config/group/getDeviceListByInGroupId',
      data: {
        groupId: groupId,
        deviceType: deviceType
      }
    })
  },
  getDevicelListByNotInGroupId(groupId, deviceType) {
    //获取分组设备(0数值 1视频 2图片 3开关 4网关)
    return http.get({
      url: '/config/group/getDevicelListByNotInGroupId',
      data: {
        groupId: groupId,
        deviceType: deviceType
      }
    })
  },

  //分组保存数据
  batchGroups(dto) {
    return http.post({
      url: 'config/group/batchGroups',
      data: dto,
      typea: 1
    })
  },

  addDeviceSwtich(dto) {
    //添加开关设备
    return http.post({
      url: 'objdeviceSwtich/addDeviceSwtich',
      data: dto
    })
  },
  updateDeviceSwtich(dto) {
    //编辑开关设备
    return http.post({
      url: 'objdeviceSwtich/updateDeviceSwtich',
      data: dto
    })
  },
  getDeviceSwtich(id) {
    //获取开关详情
    return http.get({
      url: 'objdeviceSwtich/getDeviceSwtich',
      data: {
        id: id
      }
    })
  },
  picCapture(id) {
    //图片抓拍
    return http.post({
      url: 'objdevicePic/picCapture',
      data: {
        id: id
      }
    })
  },

  getPicImageList(pageNum, pageSize, eid, attrid) {
    //获取图片列表
    return http.get({
      url: '/pc/sysHomeMonitor/getPicImageList',
      data: {
        pageNum: pageNum,
        pageSize: pageSize,
        eid: eid,
        attributeId: attrid
      }
    })
  },
  getVideoImageList(pageNum, pageSize, eid) {
    //获取视频列表
    return http.get({
      url: 'objdeviceVideo/getVideoImageList',
      data: {
        pageNum: pageNum,
        pageSize: pageSize,
        eid: eid
      }
    })
  },
  getDeviceSwtichList(pageNum, pageSize, name) {
    //获取开关列表
    return http.get({
      url: 'objdeviceSwtich/getSwitchAttributeList',
      data: {
        pageNum: pageNum,
        pageSize: pageSize,
        name: name
      }
    })
  },
  getDeviceSwtichList2(pageNum, pageSize, name) {
    //获取数值列表
    return http.get({
      url: 'pc/objDeviceNumerical/getNumericals',
      data: {
        pageNum: pageNum,
        pageSize: pageSize,
        name: name
      }
    })
  },
  getNumericalsByGroupId(dto) {
    //查询分组下的所有传感器
    return http.get({
      url: 'pc/objDeviceNumerical/getNumericalsByGroupId',
      data: dto
    })
  },
  getDeviceSwtichList3(pageNum, pageSize, name) {
    //获取开关列表
    return http.get({
      url: 'pc/objDeviceSwitch/getDeviceSwtichs',
      data: {
        pageNum: pageNum,
        pageSize: pageSize,
        name: name
      }
    })
  },
  getAllDeviceSwitchs(dto) {
    //获取开关列表
    return http.get({
      url: 'pc/objDeviceSwitch/getSwitchs',
      data: dto
    })
  },

  getAttributesBySwtichId(id) {
    //获取开关属性
    return http.get({
      url: 'pc/objDeviceSwitch/getAttributesBySwtichId',
      data: {
        id: id
      }
    })
  },
  openOrCloseDevice(id) {
    //数值设备启用停用
    return http.post({
      url: 'objdeviceNumerical/openOrCloseDevice',
      data: {
        id: id
      }
    })
  },
  openOrCloseDevice2(id) {
    //视频设备启用停用
    return http.post({
      url: 'objdeviceVideo/openOrCloseDevice',
      data: {
        id: id
      }
    })
  },
  openOrCloseDevice3(id) {
    //图片设备启用停用
    return http.post({
      url: 'objdevicePic/openOrCloseDevice',
      data: {
        id: id
      }
    })
  },
  openOrCloseDevice4(id) {
    //开关设备启用停用
    return http.post({
      url: 'objdeviceSwtich/openOrCloseDevice',
      data: {
        id: id
      }
    })
  },
  openOrCloseDevice5(id) {
    //网关设备启用停用
    return http.post({
      url: 'objdeviceGateway/openOrCloseDevice',
      data: {
        id: id
      }
    })
  },
  addDevice(dto) {
    //添加设备（第一步）
    return http.post({
      url: 'objdeviceNumerical/addDeviceNumerical',
      data: dto
    })
  },
  updateDeviceNumerical(dto) {
    //添加设备（第一步）
    return http.post({
      url: 'objdeviceNumerical/updateDeviceNumerical',
      data: dto
    })
  },
  saveRuleDevice(dto) {
    //添加设备类型（第一步）
    return http.post({
      url: 'model/ruleDevice/saveRuleDevice',
      data: dto
    })
  },
  updataDevice(dto) {
    //编辑设备
    return http.post({
      url: 'iotDevice/updateIotDevice',
      data: dto
    })
  },
  updateIotDeviceClasses(dto) {
    //编辑分类
    return http.post({
      url: 'iotDeviceClasses/updateIotDeviceClasses',
      data: dto
    })
  },
  getDevice(id) {
    //获取设备详情
    return http.get({
      url: 'iotDevice/getIotDevice',
      data: {
        id: id
      }
    })
  },
  getIotDeviceClasses(id) {
    //获取设备分类详情
    return http.get({
      url: 'model/ruleDevice/getRuleDevice',
      data: {
        id: id
      }
    })
  },
  getRuleDesc(id) {
    //获取设备描述详情
    return http.get({
      url: 'model/ruleDevice/getRuleDesc',
      data: {
        id: id
      }
    })
  },

  addDeviceDesc(dto) {
    //添加设备描述（第二步）
    return http.post({
      url: 'model/ruleDevice/saveRuleDescs',
      typea: 1,
      data: JSON.stringify(dto)
    })
  },
  saveAlarmSettings(dto) {
    return http.post({
      url: 'model/alarmSettings/saveAlarmSettings',
      typea: 1,
      data: JSON.stringify(dto)
    })
  },
  saveDeviceGatewayTopics(dto) {
    return http.post({
      url: 'objdeviceGateway/saveDeviceGatewayTopics',
      typea: 1,
      data: JSON.stringify(dto)
    })
  },
  saveDeviceSwtich(dto) {
    return http.post({
      url: 'objdeviceSwtich/saveDeviceSwtich',
      typea: 1,
      data: JSON.stringify(dto)
    })
  },

  addDeviceAttribute(dto) {
    //添加设备属性（第三步）
    return http.post({
      url: 'model/ruleDevice/saveRuleAttribute',
      data: dto
    })
  },
  saveRuleNumericConvert(dto) {
    //保存数值转换
    return http.post({
      url: 'model/ruleDevice/saveRuleNumericConvert',
      data: dto
    })
  },
  getRuleControls(id) {
    //查询控制命令列表
    return http.get({
      url: 'model/ruleDevice/getRuleControls',
      data: {
        id: id
      }
    })
  },
  getRuleControl(id) {
    //查询控制命令详情
    return http.get({
      url: 'model/ruleDevice/getRuleControl',
      data: {
        id: id
      }
    })
  },
  saveRuleControl(dto) {
    //保存控制命令
    return http.post({
      url: 'model/ruleDevice/saveRuleControl',
      data: dto
    })
  },

  updataDeviceAttribute(dto) {
    //编辑设备属性
    return http.post({
      url: 'iotDeviceAttribute/updateIotDeviceAttribute',
      data: dto
    })
  },
  getDeviceAttributeList(id) {
    //查询设备属性列表
    return http.get({
      url: '/model/ruleDevice/getRuleAttributes',
      data: {
        id: id
      }
    })
  },
  getRuleNumericConverts(id) {
    //查询数值转换列表
    return http.get({
      url: '/model/ruleDevice/getRuleNumericConverts',
      data: {
        id: id
      }
    })
  },
  getDeviceAttribute(id) {
    //查询设备属性详情
    return http.get({
      url: 'model/ruleDevice/getRuleAttribute',
      data: {
        id: id
      }
    })
  },
  getRuleNumericConvert(id) {
    //查询数值转换详情
    return http.get({
      url: 'model/ruleDevice/getRuleNumericConvert',
      data: {
        id: id
      }
    })
  },
  getDeviceSwitchs(id, attrid) {
    //查询控制面板详情
    return http.get({
      url: 'objdeviceSwtich/getDeviceSwitchs',
      data: {
        eid: id,
        attributeId: attrid
      }
    })
  },
  addDeviceTopic(dto) {
    //添加设备主题信息（第四步）
    return http.post({
      url: 'iotDeviceTopic/addIotDeviceTopic',
      data: dto
    })
  },
  getDevicesByGroupId(id) {
    return http.get({
      url: 'objdeviceNumerical/getDevicesByGroupId',
      data: {
        id: id
      }
    })
  },
  updataDeviceTopic(dto) {
    return http.post({
      url: 'iotDeviceTopic/updateIotDeviceTopic',
      data: dto
    })
  },

  getDeviceTopic(id) {
    return http.get({
      url: 'iotDeviceTopic/getIotDeviceTopic',
      data: {
        id: id
      }
    })
  },
  getDeviceTopicList(id) {
    //查询设备主题列表
    return http.get({
      url: 'iotDeviceTopic/getIotDeviceTopicByEid',
      data: {
        classesId: id
      }
    })
  },
  addDeviceCode(dto) {
    //添加设备编码信息（第五步）
    return http.post({
      url: 'model/ruleDevice/saveRuleDevicecode',
      data: dto
    })
  },
  saveRuleRespcondition(dto) {
    //添加设备编码信息（第五步）
    return http.post({
      url: 'model/ruleDevice/saveRuleRespcondition',
      data: dto
    })
  },
  updataDeviceCode(dto) {
    //编辑设备编码信息
    return http.post({
      url: 'iotRuleDevicecode/updateIotRuleDevicecode',
      data: dto
    })
  },
  getRuleRespcondition(id) {
    //查询详情
    return http.get({
      url: 'model/ruleDevice/getRuleRespcondition',
      data: {
        id: id
      }
    })
  },
  getRuleRespmesg(id) {
    //查询详情
    return http.get({
      url: 'model/ruleDevice/getRuleRespmesg',
      data: {
        id: id
      }
    })
  },

  getDeviceCode(id) {
    //查询设备编码详情
    return http.get({
      url: 'model/ruleDevice/getRuleDevicecode',
      data: {
        id: id
      }
    })
  },
  addDeviceRule(dto) {
    //添加设备数据解析规则（第六步）
    return http.post({
      url: 'model/ruleDevice/saveRuleDevicedatas',
      data: dto
    })
  },
  saveRuleRespmesg(dto) {
    //添加设备数据解析规则（第六步）
    return http.post({
      url: 'model/ruleDevice/saveRuleRespmesg',
      data: dto
    })
  },
  updataDeviceRule(dto) {
    return http.post({
      url: 'iotRuleDevicedata/updateIotRuleDevicedata',
      data: dto
    })
  },
  getDeviceRule(id) {
    //查询详情
    return http.get({
      url: 'model/ruleDevice/getRuleDevicedata',
      data: {
        id: id
      }
    })
  },
  getDeviceRuleList(id, flag) {
    //查询列表
    return http.get({
      url: 'model/ruleDevice/getRuleDevicedatas',
      data: {
        modelRuleDeviceId: id,
        flag: flag
      }
    })
  },
  getRuleRespmesgs(id) {
    //查询列表
    return http.get({
      url: 'model/ruleDevice/getRuleRespmesgs',
      data: {
        id: id
      }
    })
  },
  addDeviceCommand(dto) {
    //添加设备数据解析规则（第八步）
    return http.post({
      url: 'model/ruleDevice/saveRuleCmd',
      data: dto
    })
  },
  updataDeviceCommand(dto) {
    return http.post({
      url: 'iotCmdModbus/updateIotCmdModbus',
      data: dto
    })
  },
  getDeviceCommand(id) {
    //查询详情
    return http.get({
      url: 'model/ruleDevice/getRuleCmd',
      data: {
        id: id
      }
    })
  },
  getDeviceNumerical(id) {
    //查询设备详情
    return http.get({
      url: 'objdeviceNumerical/getDeviceNumerical',
      data: {
        id: id
      }
    })
  },
  getDeviceCommandList(id) {
    //查询列表
    return http.get({
      url: 'model/ruleDevice/getRuleCmds',
      data: {
        id: id
      }
    })
  },

  addDeviceCommand2(dto) {
    //添加设备数据解析规则（第八步）
    return http.post({
      url: 'iotCmdOthers/addIotCmdOthers',
      data: dto
    })
  },
  updataDeviceCommand2(dto) {
    return http.post({
      url: 'iotCmdOthers/updateIotCmdOthers',
      data: dto
    })
  },
  getDeviceCommand2(id) {
    //查询详情
    return http.get({
      url: 'iotCmdOthers/getIotCmdOthers',
      data: {
        id: id
      }
    })
  },
  getDeviceCommandList2(id) {
    //查询列表
    return http.get({
      url: 'iotCmdOthers/getIotCmdOthersList',
      data: {
        classesId: id
      }
    })
  },

  getNumericalDeviceAttribute(eid, id) {
    //查询设备具体属性的地理位置
    return http.get({
      url: 'objdeviceNumerical/getNumericalDeviceAttribute',
      data: {
        attributeId: eid,
        eid: id
      }
    })
  },
  getRealDataChart(eid, id) {
    //查询设备具体属性的曲线图
    return http.get({
      url: 'data/statistic/getRealDataChart',
      data: {
        attributeId: eid,
        eid: id
      }
    })
  },
  getDataHisDataChart(eid, id, startDate, endDate, dateType) {
    //查询设备具体属性的曲线图
    return http.get({
      url: 'data/statistic/getDataHisDataChart',
      data: {
        attributeId: eid,
        eid: id,
        startDate: startDate,
        endDate: endDate,
        dateType: dateType
      }
    })
  },
  getHisAlarmList(pageNum, pageSize, type, id, eid) {
    //查询设备具体属性的曲线图
    return http.get({
      url: 'data/alarm/getHisAlarmList',
      data: {
        pageNum: pageNum,
        pageSize: pageSize,
        type: type,
        attributeId: id,
        eid: eid
      }
    })
  },

  getDataHisDataList(pageNum, pageSize, id, eid, startDate, endDate, dateType) {
    //查询设备具体属性的历史数据表格
    return http.get({
      url: 'data/statistic/getDataHisDataList',
      data: {
        pageNum: pageNum,
        pageSize: pageSize,
        attributeId: id,
        eid: eid,
        startDate: startDate,
        endDate: endDate,
        dateType: dateType
      }
    })
  },
  exportDataHisDatas(id, eid, startDate, endDate, dateType) {
    //导出历史数据表格
    return http.post({
      url: 'data/statistic/exportDataHisDatas',
      data: {
        attributeId: id,
        eid: eid,
        startDate: startDate,
        endDate: endDate,
        dateType: dateType
      }
    })
  },

  getCmdModbusList(type, id) {
    //查询mudebus列表
    return http.get({
      url: 'config/cmdModbus/getCmdModbusList',
      data: {
        type: type,
        eid: id
      }
    })
  },

  addGroup(dto) {
    //添加分组
    return http.post({
      url: 'config/group/addGroup',
      data: dto
    })
  },
  updateIotGroup(dto) {
    //编辑分组
    return http.post({
      url: 'config/group/updateGroup',
      data: dto
    })
  },
  getIotGroup(id) {
    //获取分组详情
    return http.get({
      url: 'config/group/getGroup',
      data: {
        id: id
      }
    })
  },
  getRealDatasByEid(id) {
    //获取设备属性
    return http.get({
      url: 'objdeviceNumerical/getRealDatasByEid',
      data: {
        id: id
      }
    })
  },

  getallGroup() {
    //获取分组下拉
    return http.get({
      url: 'config/group/getGroups'
    })
  },
  getMyGroups() {
    //获取分组下拉
    return http.get({
      url: 'config/group/getMyGroups'
    })
  },
  getAlarmSettingss() {
    //获取告警模板下拉
    return http.get({
      url: 'model/alarmSettings/getAlarmSettingss'
    })
  },
  getGroupLis(pageNum, pageSize, name) {
    //获取所有设备地理位置
    return http.get({
      url: 'config/group/getGroupList',
      data: {
        pageNum: pageNum,
        pageSize: pageSize,
        name: name
      }
    })
  },

  updateDeviceVideoPosition(dto) {
    return http.post({
      url: 'objdeviceVideo/videoPtz',
      data: dto
    })
  },
  saveRuleDecodeCondition(dto) {
    return http.post({
      url: 'model/ruleDevice/saveRuleDecodeCondition',
      data: dto
    })
  },

  getRuleDecodeCondition(id) {
    return http.get({
      url: 'model/ruleDevice/getRuleDecodeCondition',
      data: {
        id: id
      }
    })
  },
  getDevicePositions(attributeKey, groupId, status) {
    //获取所有设备地理位置
    return http.get({
      url: 'objdeviceNumerical/getDevicePositions',
      data: {
        name: attributeKey,
        groupId: groupId,
        status: status
      }
    })
  },
  getDeviceMessageList(pageNum, pageSize, readStatus) {
    //获取设备告警信息
    return http.get({
      url: 'data/message/getDeviceMessageList',
      data: {
        pageNum: pageNum,
        pageSize: pageSize,
        type: 0,
        readStatus: readStatus
      }
    })
  },
  getRuleCmds(id) {
    //获取命令模板下拉
    return http.get({
      url: 'model/ruleDevice/getRuleCmds',
      data: {
        id: id
      }
    })
  },

  getDeviceDesc() {
    //获取设备分类下拉
    return http.get({
      url: 'iotDeviceClasses/getDeviceDesc'
    })
  },

  getDeviceGatewayList() {
    //获取网关下拉
    return http.get({
      url: 'objdeviceGateway/getDeviceGatewayList',
      data: {
        pageNum: 1,
        pageSize: 1000
      }
    })
  },
  getDeviceStatusChart() {
    //获取首页设备状态
    return http.get({
      url: 'data/statistic/getDeviceStatusChart'
    })
  },
  getOfflineDeviceChart() {
    //获取首页离线设备
    return http.get({
      url: 'data/statistic/getOfflineDeviceChart'
    })
  },
  getIotRealDataByDeviceId(id) {
    //获取设备下的属性实时数据
    return http.get({
      url: 'iotRealData/getIotRealDataByDeviceId',
      data: {
        id: id
      }
    })
  },
  getAttributesByEid(id) {
    //根据设备id获取所有属性
    return http.get({
      url: 'pc/objDeviceNumerical/getAttributesByEid',
      data: {
        id: id
      }
    })
  },

  //联动控制
  saveLinkageControl(dto) {
    //联动控制第一步
    return http.post({
      url: 'pc/linkageControl/saveLinkageControl',
      data: dto
    })
  },

  getControl(id) {
    //第一步获取详情
    return http.get({
      url: 'pc/linkageControl/getLinkageControl',
      data: {
        id: id
      }
    })
  },

  saveLinkageControlTime(dto) {
    //联动控制第二步（定时设置保存）
    return http.post({
      url: 'pc/linkageControl/saveLinkageControlTime',
      data: dto
    })
  },
  getTimeListByControlId(id) {
    //第二步列表数据
    return http.get({
      url: 'pc/linkageControl/getLinkageControlTimeList',
      data: {
        controlId: id
      }
    })
  },
  getTimeById(id) {
    //第二步查询列表数据详情
    return http.get({
      url: 'pc/linkageControl/getLinkageControlTime',
      data: {
        id: id
      }
    })
  },

  saveLinkageControlCondition(dto) {
    //联动控制第二步（自动设置保存）
    return http.post({
      url: 'pc/linkageControl/saveLinkageControlCondition',
      typea: 1,
      data: JSON.stringify(dto)
    })
  },
  getConditionListByControlId(id) {
    //第二步列表数据
    return http.get({
      url: 'pc/linkageControl/getLinkageControlConditionList',
      data: {
        controlId: id
      }
    })
  },
  getConditionById(id) {
    //第二步查询列表数据详情
    return http.get({
      url: 'pc/linkageControl/getLinkageControlCondition',
      data: {
        id: id
      }
    })
  },
  getWaterEquipmentList(data) {
    //获取水肥机列表
    return http.get({
      url: '/pc/agriConfigWaterEquipment/getWaterEquipmentList',
      data: data
    })
  },
  getAllPipeAndSwitchById(data) {
    //获取水肥机列表
    return http.get({
      url: '/pc/agriConfigWaterEquipment/getAllPipeAndSwitchById',
      data: data
    })
  },
  getWaterEquipment(data) {
    //获取水肥机详情
    return http.get({
      url: '/pc/agriConfigWaterEquipment/getWaterEquipment',
      data: data
    })
  },
  getDeviceByEquipmentId(id) {
    //获取水肥机开关列表
    return http.get({
      url: 'pc/agriConfigWaterEquipment/getDeviceByEquipmentId',
      data: {
        controlId: id,
        type: 3
      }
    })
  },
  getRotationalIrrigationList(data) {
    //获取轮灌组列表
    return http.get({
      url: '/pc/agriConfigWaterEquipment/getRotationalIrrigationList',
      data: data
    })
  },
  getAllDeviceAttributes() {
    return http.get({
      url: '/pc/agriConfigWaterEquipment/getAllDeviceAttributes'
    })
  },
  getSwitchAndNumberDeviceAttributes(data) {
    return http.get({
      url: '/pc/agriConfigWaterEquipment/getSwitchAndNumberDeviceAttributes',
      data: data
    })
  },
  saveWaterEquipment(dto) {
    //保存水肥机
    return http.post({
      url: 'pc/agriConfigWaterEquipment/saveWaterEquipment',
      typea: 1,
      data: JSON.stringify(dto)
    })
  },
  updateControlType(dto) {
    //水肥机切换
    return http.post({
      url: 'pc/agriConfigWaterEquipment/updateControlType',
      typea: 1,
      data: JSON.stringify(dto)
    })
  },
  getTriggerCondition(id) {
    //获取水肥机触发条件列表
    return http.get({
      url: 'pc/agriConfigWaterEquipment/getTriggerCondition',
      data: {
        controlId: id
      }
    })
  },
  saveRotationalIrrigationList(dto) {
    //保存轮灌组
    return http.post({
      url: 'pc/agriConfigWaterEquipment/saveRotationalIrrigationList',
      typea: 1,
      data: JSON.stringify(dto)
    })
  },
  getActionListByControlId(id) {
    //第三步列表数据
    return http.get({
      url: 'pc/linkageControl/getLinkageControlActionList',
      data: {
        controlId: id
      }
    })
  },
  saveLinkageControlAction(dto) {
    //联动控制第三步（自动设置保存）
    return http.post({
      url: 'pc/linkageControl/saveLinkageControlAction',
      typea: 1,
      data: JSON.stringify(dto)
    })
  },
  saveEquipmentConfig(dto) {
    // 保存开关配置
    return http.post({
      url: 'pc/linkageControl/saveEquipmentConfig',
      typea: 1,
      data: JSON.stringify(dto)
    })
  },
  getEquipmentConfigById(id) {
    // 获取开关配置
    return http.get({
      url: 'pc/linkageControl/getEquipmentConfigById',
      data: {
        id: id
      }
    })
  },
  getActionByDeviceId(id) {
    //三步查询列表数据详情
    return http.get({
      url: 'pc/linkageControl/getLinkageControlAction',
      data: {
        id: id
      }
    })
  },

  delfun(url, id, type) {
    //公用删除方法
    return http.post({
      url: url,
      data: {
        id: id,
        type: type,
        _method: 'delete'
      }
    })
  },
  delfun2(url, id, type) {
    //公用删除方法
    return http.post({
      url: url,
      data: {
        id: id,
        type: type,
        _method: 'delete'
      }
    })
  },
  delfun3(url, id, eid, type) {
    //公用删除方法
    return http.post({
      url: url,
      data: {
        eid: id,
        lingkageControlId: eid,
        type: type,
        _method: 'delete'
      }
    })
  },
  saveTriggerCondition(dto) {
    //添加图片设备
    return http.post({
      url: 'pc/agriConfigWaterEquipment/saveTriggerCondition',
      data: dto
    })
  },
  /**
   * 水管开关
   * @param {*} id
   * @param {*} type
   */
  getDeviceByEquipmentId2(id, type) {
    //获取水肥机开关列表
    return http.get({
      url: 'pc/agriConfigWaterEquipment/getDeviceByEquipmentId',
      data: {
        controlId: id,
        type: type
      }
    })
  },
  /**
   * 获取水肥机水管列表
   * @param {*} data
   */
  getWaterPipeList(data) {
    //获取水肥机开关列表
    return http.get({
      url: 'pc/agriConfigWaterPipe/getWaterPipeList',
      data: {
        ...data
      }
    })
  },
  /**
   * 保存水管
   * @param {*} data
   */
  saveWaterPipe(data) {
    return http.post({
      url: 'pc/agriConfigWaterPipe/saveWaterPipe',
      data: data,
      typea: 1
    })
  },
  /**
   * 获取水肥机水管详情
   * @param {*} data
   */
  getWaterPipe(data) {
    //获取水肥机开关列表
    return http.get({
      url: 'pc/agriConfigWaterPipe/getWaterPipe',
      data: {
        ...data
      }
    })
  },

  // 获取水肥机列表
  getAllWaterEquipmentAndPipe(data) {
    //获取水肥机开关列表
    return http.get({
      url: 'pc/agriConfigWaterEquipment/getAllWaterEquipmentAndPipe'
    })
  },

  // 获取全部数值设备列表
  getDeviceNumericalAll() {
    return http.get({
      url: '/pc/objDeviceNumerical/getNumericals',
      data: {}
    })
  },
  // 根据开关id获取属性
  getAttributesBySwtichId(data) {
    return http.get({
      url: '/pc/objDeviceSwitch/getAttributesBySwtichId',
      data: {
        ...data
      }
    })
  },
  // 根据开关id获取属性
  getAttributeModelRuleSwitchCmds(data) {
    return http.get({
      url: '/pc/objDeviceSwitch/getAttributeModelRuleSwitchCmds',
      data: {
        ...data
      }
    })
  },
  // 获取全部视频设备列表
  getDeviceVideoAll() {
    return http.get({
      url: '/pc/objDeviceVideo/getVideos',
      data: {}
    })
  },

  // 获取全部开关设备列表
  getDeviceSwitchAll() {
    // 获取全部开关设备列表
    return http.get({
      url: 'pc/objDeviceSwitch/getSwitchs',
      data: {}
    })
  },

  // 获取全部网关设备列表
  getDeviceGatewayAll() {
    // 获取全部网关设备列表
    return http.get({
      url: 'pc/objDeviceGateway/getGateways',
      data: {}
    })
  },

  // 获取设备属性列表
  getDeviceAttributes(dto) {
    // 获取设备属性列表
    return http.get({
      url: 'pc/modelRuleDevice/getDeviceAttributes',
      data: dto
    })
  },

  // 获取用户提醒机制
  getUserRemindMechanism(dto) {
    return http.get({
      url: 'pc/linkageControlRemindMechanism/getUserRemindMechanism',
      data: dto
    })
  },

  // 保存用户提醒机制
  saveUserRemindMechanism(dto) {
    return http.post({
      url: 'pc/linkageControlRemindMechanism/saveUserRemindMechanism',
      data: dto,
      typea: 1
    })
  },

  // 获取水肥机配比列表
  getIrrigationProportionList(dto) {
    return http.get({
      url: 'pc/agriConfigIrrigationProportion/getIrrigationProportionList',
      data: dto
    })
  },

  // 获取水肥机配比
  getIrrigationProportion(dto) {
    return http.get({
      url: 'pc/agriConfigIrrigationProportion/getIrrigationProportion',
      data: dto
    })
  },

  // 保存水肥机配比
  saveIrrigationProportion(dto) {
    return http.post({
      url: 'pc/agriConfigIrrigationProportion/saveIrrigationProportion',
      data: dto,
      typea: 1
    })
  },

  // 删除水肥机配比
  delIrrigationProportion(id) {
    return http.post({
      url: 'pc/agriConfigIrrigationProportion/delIrrigationProportion',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },

  // 获取分组下所有摄像头
  getVideosByGroupId(dto) {
    return http.get({
      url: 'pc/objDeviceVideo/getVideosByGroupId',
      data: dto
    })
  },

  // 获取分组下所有开关
  getSwitchsByGroupId(dto) {
    return http.get({
      url: 'pc/objDeviceSwitch/getSwitchs',
      data: dto
    })
  },

  // 获取设备位置列表
  getObjDevicePositionList(dto) {
    return http.get({
      url: '/pc/objDevicePosition/getObjDevicePositionList',
      data: dto
    })
  },

  // 获取全部设备位置列表
  getObjDevicePositions(dto) {
    return http.get({
      url: '/pc/objDevicePosition/getObjDevicePositions',
      data: dto
    })
  },

  // 获取设备位置
  getObjDevicePosition(dto) {
    return http.get({
      url: '/pc/objDevicePosition/getObjDevicePosition',
      data: dto
    })
  },
  // 获取决策模型（控制柜名称）
  getGrowthModelDecisionByDeviceName(dto) {
    return http.get({
      url: '/pc/growthModelDecision/getGrowthModelDecisionByDeviceName',
      data: dto
    })
  },
  // 保存设备位置
  saveObjDevicePosition(dto) {
    return http.post({
      url: '/pc/objDevicePosition/saveObjDevicePosition',
      data: dto,
      typea: 1
    })
  },

  // 删除设备位置
  delObjDevicePosition(id) {
    return http.post({
      url: '/pc/objDevicePosition/delObjDevicePosition',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },
  getDataHisSwitchList(dto) {
    //获取开关设备历史记录
    return http.get({
      url: 'pc/dataHisSwitch/getDataHisSwitchList',
      data: dto
    })
  },
  getAnalogicalAna1lysisChart(dto) {
    //获取开关设备历史记录
    return http.post({
      url: 'pc/sysHomeMonitor/getAnalogicalAna1lysisChart',
      typea: 1,
      data: JSON.stringify(dto)
    })
  },
  getChainAnalysisChart(dto) {
    //获取开关设备历史记录
    return http.post({
      url: 'pc/sysHomeMonitor/getChainAnalysisChart',
      typea: 1,
      data: JSON.stringify(dto)
    })
  },
  getDataHisInsectList(dto) {
    //获取开关设备历史记录
    return http.get({
      url: 'pc/sysHomeMonitor/getDataHisInsectList',
      data: dto
    })
  },
  getHomeDeviceCount(dto) {
    //获取开关设备历史记录
    return http.get({
      url: '/pc/sysHomeMonitor/getHomeDeviceCount',
      data: dto
    })
  },
  getHomeMonitorList(dto) {
    //获取开关设备历史记录
    return http.get({
      url: '/pc/sysHomeMonitor/getHomeMonitorList',
      data: dto
    })
  },
  getInsectRank(insectStationId, type) {
    //获取图片列表
    return http.get({
      url: '/pc/sysHomeMonitor/getInsectRank',
      data: {
        insectStationId: insectStationId,
        type: 1
      }
    })
  },
  getInsectStations(dto) {
    //获取开关设备历史记录
    return http.get({
      url: '/pc/sysHomeMonitor/getInsectStations',
      data: dto
    })
  },
  getStatisticalCurve(dto) {
    //获取开关设备历史记录
    return http.get({
      url: '/pc/sysHomeMonitor/getStatisticalCurve',
      data: dto
    })
  },
  getDataHisImageList(pageNum, pageSize, stationId, orderBy) {
    //获取图片列表
    return http.get({
      url: '/pc/sysHomeMonitor/getDataHisImageList',
      data: {
        pageNum: pageNum,
        pageSize: pageSize,
        stationId: stationId,
        orderBy: 1
      }
    })
  },
  getDashScopeLogList(type) {
    //获取图片列表
    return http.get({
      url: '/pc/dashScopeLog/getDashScopeLogList',
      data: {
        pageNum: 1,
        pageSize: 500,
        type: type,//0蓝莓，1草莓
      }
    })
  },
  getAIInstantAnswer(str) {
    //获取开关设备历史记录
    return http.get({
      url: 'pc/dashScopeLog/getAIInstantAnswer',
      data: {
        str:str
      }
    })
  },
}
export default apis
